import { render } from "./ServiceCompoent.vue?vue&type=template&id=0c979d65"
import script from "./ServiceCompoent.vue?vue&type=script&lang=js"
export * from "./ServiceCompoent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__